export const LOCATION_PERMISSION_DISMISS_KEY = "repo.locationPermissionDismissed";
export const LOCATION_PERMISSION_GRANTED_KEY = "repo.locationPermissionGranted";
export const LOCATION_VALIDATED_KEY = "repo.locationValidated";
export const MY_LAST_LOCATION_KEY = "repo.myLastLocation";

/** “Not now” — only for this browser session so login / next visit can ask again. */
export function isLocationPermissionDismissed() {
  try {
    if (window.localStorage.getItem(LOCATION_PERMISSION_DISMISS_KEY) === "1") {
      window.sessionStorage.setItem(LOCATION_PERMISSION_DISMISS_KEY, "1");
      window.localStorage.removeItem(LOCATION_PERMISSION_DISMISS_KEY);
    }
    return window.sessionStorage.getItem(LOCATION_PERMISSION_DISMISS_KEY) === "1";
  } catch {
    return false;
  }
}

export function markLocationPermissionDismissed() {
  try {
    window.sessionStorage.setItem(LOCATION_PERMISSION_DISMISS_KEY, "1");
  } catch {
    /* ignore */
  }
}

/** User allowed location — do not show the prompt again. */
export function markLocationPermissionGranted() {
  try {
    window.localStorage.setItem(LOCATION_PERMISSION_GRANTED_KEY, "1");
    window.sessionStorage.removeItem(LOCATION_PERMISSION_DISMISS_KEY);
  } catch {
    /* ignore */
  }
}

export function isLocationPermissionGranted() {
  try {
    return window.localStorage.getItem(LOCATION_PERMISSION_GRANTED_KEY) === "1";
  } catch {
    return false;
  }
}

export function clearLocationPermissionGranted() {
  try {
    window.localStorage.removeItem(LOCATION_PERMISSION_GRANTED_KEY);
  } catch {
    /* ignore */
  }
}

export function markLocationValidated() {
  try {
    window.sessionStorage.setItem(LOCATION_VALIDATED_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function isLocationValidated() {
  try {
    return window.sessionStorage.getItem(LOCATION_VALIDATED_KEY) === "1";
  } catch {
    return false;
  }
}

export function storeMyLastLocation(coords) {
  try {
    window.sessionStorage.setItem(MY_LAST_LOCATION_KEY, JSON.stringify(coords || {}));
  } catch {
    /* ignore */
  }
}

export function readMyLastLocation() {
  try {
    const raw = window.sessionStorage.getItem(MY_LAST_LOCATION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearLocationPermissionSession() {
  try {
    window.sessionStorage.removeItem(LOCATION_PERMISSION_DISMISS_KEY);
    window.localStorage.removeItem(LOCATION_PERMISSION_DISMISS_KEY);
    window.localStorage.removeItem(LOCATION_PERMISSION_GRANTED_KEY);
    window.sessionStorage.removeItem(LOCATION_VALIDATED_KEY);
    window.sessionStorage.removeItem(MY_LAST_LOCATION_KEY);
  } catch {
    /* ignore */
  }
}
